<template>
	<button
		style="background-color: #0cc4c3 !important;"
		:type="type"
		class="button text-white font-montserrat-bold bg-blue-light text-[16px] font-bold rounded-[10px]"
		:class="[`${classes}`]"
		@click="handleClick"
	>
		{{ label }}
	</button>
</template>

<script>
export default {
	emits: ['onClick'],
	name: 'GeeqButtonComponent',
	props: {
		type: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		classes: {
			type: String,
			default: '',
		},
	},
	methods: {
		handleClick() {
			// handle button click event
			this.$emit('onClick');
		},
	},
};
</script>

<style scoped>
.button {
  padding: 12px;
  line-height: 5px;
  color: white;
  background: #0cc4c3;
}
.button:hover {
  background: linear-gradient(90deg, #0cc4c3 0%, #65E1E5 100%);
}
</style>
